import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popconfirm, Divider, Button } from 'antd';
import {
  EditOutlined,
  WarningOutlined,
  DeleteOutlined
} from '@ant-design/icons';

const useColumns = (callBackEdit, callBackDelete) => {
  const { t } = useTranslation();

  return [
    {
      title: t('settings.team.form.gender'),
      dataIndex: 'gender',
      key: 'gender',
      render: (gender) => t(`contacts.tags.${gender}`),
      sorter: true
    },
    {
      title: t('settings.team.form.last_name'),
      dataIndex: 'last_name',
      key: 'last_name',
      sorter: true
    },
    {
      title: t('settings.team.form.first_name'),
      dataIndex: 'first_name',
      key: 'first_name',
      sorter: true,
      ellipsis: true
    },
    {
      title: t('settings.team.form.position'),
      dataIndex: 'position',
      key: 'position',
      sorter: true,
      render: (position) => {
        if (!position) return '';
        const value =
          position.value[0] === 'OTHER'
            ? position.comment
            : t(`insurers.form.enums.${position?.value}`);
        return <span>{value}</span>;
      }
    },
    {
      title: t('settings.team.form.email'),
      dataIndex: 'email',
      render: (email) => (
        <a href={`mailto:${email}`} target="_blank" rel="noopener noreferrer">
          {email}
        </a>
      ),
      key: 'email',
      sorter: true
    },
    {
      title: t('settings.team.form.phone_number'),
      sorter: true,
      render: (record) =>
        record?.phone_number ? (
          <>
            <a
              href={`tel:${record.phone_number}`}
              style={{ fontWeight: 'bold' }}
            >
              {`${record?.phone_number}`}
            </a>
          </>
        ) : (
          ''
        )
    },
    {
      fixed: 'right',
      width: '8%',
      render: (record) => {
        return (
          <div>
            <Button
              type="link"
              onClick={() => callBackEdit(record)}
              style={{ padding: 0 }}
            >
              <EditOutlined style={{ fontSize: '16px' }} />
            </Button>
            <Divider orientation="vertical" />
            <Popconfirm
              title={t('datatable.column.action.delete.title')}
              okText="Supprimer"
              okButtonProps={{ type: 'danger' }}
              cancelText={t('datatable.column.action.delete.cancel')}
              onConfirm={() => callBackDelete(record.key)}
              icon={<WarningOutlined />}
            >
              <DeleteOutlined
                style={{ color: '#b51010', fontSize: '16px' }}
                type="delete"
              />
            </Popconfirm>
          </div>
        );
      }
    }
  ];
};

export default useColumns;
